import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  resetForm,
  getEmployeeById,
  getCustomFieldsEmployees,
  modifyEmployee,
  modifyCustomField,
  addEmployee,
  updateEmployee,
  setFile,
  uploadFile,
} from 'employees/actions';

import { getEditing } from 'employees/selectors';
import { getCompany, getSubcompany } from 'auth/selectors';
import { addGrowlError, addGrowlSuccess } from 'messages/actions';
import { getGroups } from 'groups/actions';

import { valueFromEvent, createRoute } from 'lib/util';

class EmployeesFormHandlers extends Component {
  static propTypes = {
    render: PropTypes.func.isRequired,
  };

  state = { isSubmitted: false, isValid: false, isSaving: false };

  componentWillMount = () => {
    const { eid } = this.props.match.params;
    this.props.reset();
    eid && this.props.getById(eid, this.props.company.id, this.props.subcompany.id);
    this.props.getCustomFields(this.props.company.id, this.props.subcompany.id);
    const filters = { fulltext: 'empleados', columnSearch: ['module'] }; // Filtros para traer solo los grupos de empleados
    this.props.getGroups(this.props.company.id, this.props.subcompany.id, filters);
  };

  handleSubmit = ({ isValid }) => {
    this.setState({ isSubmitted: true, isValid, isSaving: true }, async () => {
      if (isValid) {
        let employee = { ...this.props.employee };
        if (this.props.employee.img) {
          const {
            value: {
              files: [file],
            },
          } = await this.props.uploadFile(
            this.props.employee.img,
            this.props.company.id,
            this.props.subcompany.id
          );
          employee.imgUrl = file.url;
        }
        const promise = this.props.employee.id
          ? this.props.update(
              this.props.employee.id,
              this.props.company.id,
              this.props.subcompany.id,
              employee
            )
          : this.props.add(this.props.company.id, this.props.subcompany.id, employee);

        promise
          .then(({ value }) => {
            this.props.success(value.message);
            this.props.history.push(
              createRoute(this.props.company.id, this.props.subcompany.id, 'employees')
            );
          })
          .catch((err) => {
            this.props.error(err.message);
            this.finishSaving();
          });
      } else {
        this.props.error('error.verify');
        this.finishSaving();
      }
    });
  };

  finishSaving = () => this.setState({ isSaving: false });

  handleValueChange = (e) => this.props.modify(valueFromEvent(e)); // Normal para input

  handleGroupChange = (e) => {
    const { value } = e.target;
    let _group = [{ _id: value }];
    if (value == 'null' || value == '' || value == null || value == undefined) _group = [];
    this.props.modify({ _group });
  };

  handleCustomFieldChange = (e) => this.props.modifyCustomField(valueFromEvent(e)); // Especial para custom fields

  handleValidation = (isValid) => this.setState({ isValid });

  onDragEnter = () => this.setState({ activeImg: true });

  onDragLeave = () => this.setState({ activeImg: false });

  handleFileSelected = (files) => {
    // Maneja la seleccion de archivo
    if (Array.isArray(files) && files.length == 0) {
      this.props.error('import.error.fileType');
    } else {
      this.props.setFile(files.pop());
    }
  };

  render = () =>
    this.props.render({
      isSaving: this.state.isSaving,
      isSubmitted: this.state.isSubmitted,
      handleSubmit: this.handleSubmit,
      handleValueChange: this.handleValueChange,
      handleValidation: this.handleValidation,
      handleCustomFieldChange: this.handleCustomFieldChange,
      handleGroupChange: this.handleGroupChange,
      activeImage: this.state.activeImg,
      onDragEnter: this.onDragEnter,
      onDragLeave: this.onDragLeave,
      handleFileSelected: this.handleFileSelected,
    });
}

const mapStateToProps = (state) => ({
  employee: getEditing(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

const mapDispatchToProps = {
  add: addEmployee,
  error: addGrowlError,
  getById: getEmployeeById,
  getCustomFields: getCustomFieldsEmployees,
  getGroups: getGroups,
  modifyCustomField: modifyCustomField,
  modify: modifyEmployee,
  reset: resetForm,
  success: addGrowlSuccess,
  update: updateEmployee,
  setFile,
  uploadFile,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EmployeesFormHandlers));



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/containers/EmployeeFormHandlers.js